export default "/images/fbaec9d746881065e3656eb05142a716.avif";